var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConfig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;fill-rule:evenodd;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M18.333,8.18V19.167a.833.833,0,1,1-1.667,0V8.18a2.485,2.485,0,0,1,0-4.693V.833a.833.833,0,1,1,1.667,0V3.487a2.485,2.485,0,0,1,0,4.693ZM17.5,5a.833.833,0,1,0,.833.833A.834.834,0,0,0,17.5,5ZM10.833,16.513v2.653a.833.833,0,1,1-1.667,0V16.513a2.485,2.485,0,0,1,0-4.693V.833a.833.833,0,0,1,1.667,0V11.82a2.485,2.485,0,0,1,0,4.693ZM10,13.333a.833.833,0,1,0,.833.833A.834.834,0,0,0,10,13.333Zm-6.667-.987v6.82a.833.833,0,1,1-1.667,0v-6.82a2.485,2.485,0,0,1,0-4.693V.833a.833.833,0,1,1,1.667,0v6.82a2.485,2.485,0,0,1,0,4.693ZM2.5,9.167A.833.833,0,1,0,3.333,10,.834.834,0,0,0,2.5,9.167Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfig);
export default __webpack_public_path__ + "static/media/config.37064bbe925262174b5b717edc34e4fe.svg";
export { ForwardRef as ReactComponent };